import { batchManagers, employers } from '@/const/batchManagers'

export function useMainGuideEmployers() {
  const getMainGuideEmployers = (managerEmail: string) => {
    const manager = batchManagers.find(m => m.email === managerEmail)
    if (!manager || !manager.employers.length) return []

    return manager.employers
      .map(employerName => {
        const employer = employers.find(e => e.name === employerName)
        return employer ? { name: employerName, logo: employer.logo } : null
      })
      .filter((e): e is { name: string; logo: string } => e !== null)
  }

  return { getMainGuideEmployers }
}
